// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__12b1e","ranges":"BmiRanges_ranges__2SQXr"};